import { MetamodelContext } from 'metamodel/types';
import { APIFieldAttributes, Metamodel } from '@ardoq/api-types';
import {
  assetFolderIsEmpty,
  getAssetFolderComponentCompletion,
  getAssetFolderReferenceCompletion,
} from './utils';
import { AssetFolderSubtitle } from './atoms';
import { BreadCrumbNavigation } from './breadCrumbNavigation/BreadCrumbNavigation';
import { ComponentFieldCompletionWidget } from './completion/ComponentFieldCompletionWidget';
import { ReferenceFieldCompletionWidget } from './completion/ReferenceFieldCompletionWidget';
import { WorkspaceNavigationTitle } from './workspaceNavigationTitle/WorkspaceNavigationTitle';
import { DefaultNotification } from '@ardoq/status-ui';
import { Box } from '@ardoq/layout';
import { t, type I18nLocale } from '@ardoq/i18n';

const AssetFolderStats = ({
  context,
  metamodel,
  nonTemplateFieldsByName,
  i18nLocale,
}: {
  context: MetamodelContext;
  metamodel: Metamodel;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  i18nLocale: I18nLocale;
}) => {
  const content = metamodel.metamodel;

  const componentCompletion = getAssetFolderComponentCompletion(
    context,
    content
  );
  const referenceCompletion = getAssetFolderReferenceCompletion(
    context,
    content
  );

  return (
    <Box position="relative">
      <BreadCrumbNavigation
        metamodel={metamodel}
        context={context}
        nonTemplateFieldsByName={nonTemplateFieldsByName}
      />
      <Box marginTop="small">
        <WorkspaceNavigationTitle
          metamodel={metamodel}
          context={context}
          i18nLocale={i18nLocale}
        >
          {context.name}
        </WorkspaceNavigationTitle>
      </Box>
      <AssetFolderSubtitle
        componentCompletion={componentCompletion}
        referenceCompletion={referenceCompletion}
        i18nLocale={i18nLocale}
      />
      {assetFolderIsEmpty(context, content) ? (
        <DefaultNotification>
          {t(
            i18nLocale,
            'metamodel:stats.assetFolder.emptyAll',
            'The workspaces in this folder have no components or references'
          )}
        </DefaultNotification>
      ) : (
        <>
          <ComponentFieldCompletionWidget
            componentTypeFieldCompletion={componentCompletion}
            content={content}
            context={context}
            notification={t(
              i18nLocale,
              'metamodel:stats.assetFolder.emptyComponents',
              'The workspaces in this folder have no components'
            )}
            i18nLocale={i18nLocale}
          />
          <ReferenceFieldCompletionWidget
            referenceTypeFieldCompletion={referenceCompletion}
            content={content}
            context={context}
            notification={t(
              i18nLocale,
              'metamodel:stats.assetFolder.emptyReferences',
              'The workspaces in this folder have no references'
            )}
            i18nLocale={i18nLocale}
          />
        </>
      )}
    </Box>
  );
};

export { AssetFolderStats };
